import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text2vidFields", "img2vidFields", "button", "klingFields", "hunyuanFields"]

  connect() {
    this.updateVisibility()
  }

  updateType(event) {
    const button = event.currentTarget
    const type = button.querySelector('input[type="radio"]').value

    // Update button styles
    this.buttonTargets.forEach(btn => {
      btn.classList.remove("selected")
    })
    button.classList.add("selected")

    // Update fields visibility and enable/disable prompts
    this.updateVisibility(type)
  }

  updateProvider(event) {
    const provider = event.target.value
    
    // Update provider-specific fields visibility
    if (provider === "kling") {
      this.klingFieldsTarget.classList.remove("hidden")
      this.hunyuanFieldsTarget.classList.add("hidden")
    } else if (provider === "hunyuan") {
      this.klingFieldsTarget.classList.add("hidden")
      this.hunyuanFieldsTarget.classList.remove("hidden")
    }
  }

  updateVisibility(type = null) {
    // If type is not provided, get it from the selected radio button
    if (!type) {
      const selectedRadio = this.element.querySelector('input[name="video_generation_task[generation_type]"]:checked')
      type = selectedRadio?.value
    }

    // Update fields visibility
    if (type === "text2vid") {
      if (this.hasText2vidFieldsTarget) {
        this.text2vidFieldsTarget.classList.remove("hidden")
        this.text2vidFieldsTarget.querySelector('textarea').disabled = false
      }
      if (this.hasImg2vidFieldsTarget) {
        this.img2vidFieldsTarget.classList.add("hidden")
        this.img2vidFieldsTarget.querySelector('textarea').disabled = true
      }
    } else if (type === "img2vid") {
      if (this.hasText2vidFieldsTarget) {
        this.text2vidFieldsTarget.classList.add("hidden")
        this.text2vidFieldsTarget.querySelector('textarea').disabled = true
      }
      if (this.hasImg2vidFieldsTarget) {
        this.img2vidFieldsTarget.classList.remove("hidden")
        this.img2vidFieldsTarget.querySelector('textarea').disabled = false
      }
    }

    // Also update provider fields on initial load
    const providerSelect = this.element.querySelector('select[name="video_generation_task[provider]"]')
    if (providerSelect) {
      this.updateProvider({ target: providerSelect })
    }
  }
} 